<!--
	its frontend

	Page, submodule from App

    @file         Page_camTe.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->


<script>
    import { PAGE }                 from './config';
    import { URL_API, URL_IMG } 	from './minions';

    import {createEventDispatcher}  from "svelte";
    let dispatch =  createEventDispatcher();



// ============================ store variables ==============================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
        login = value;
    });


// ======================== Image upload and display =========================


    let imgFn_focus;
    let imgFn_disto;
    let imgSrc_focus = '/img/placeholder_focus.png';
    let imgSrc_disto = '/img/placeholder_distortion.png';


    const imageUpload = async imgContent=> {

        let pa = document.getElementById("imageUploadDOMEl");

        pa.onchange = async evt=> {

            let file = evt.target.files[0];
            if (file) {
                const formImg = new FormData();
                formImg.append('imageFile', file);
                formImg.append('jsonStr', JSON.stringify({...login}));

                const reply = await fetch(URL_API("upload_image"), {
                            method:'post',
                            body: formImg
                        })
                    .catch( err=> {
                        console.log('image upload failed')
                    });

                if (reply && reply.ok) {

                    const data = await reply.json();

                    if(imgContent.includes('focus')){
                        imgFn_focus = data["imageFilename"];
                        imgSrc_focus = URL_IMG(imgFn_focus.replace('.jpg','_proc.jpg'));
                        focusCheck();
                    }
                    if(imgContent.includes('disto')){
                        imgFn_disto = data["imageFilename"];
                        imgSrc_disto = URL_IMG(imgFn_disto.replace('.jpg','_proc.jpg'));
                        distortionCheck();
                    }
                }
                else {
                    dispatch('message', {text: "Faild to connect to server."});
                }
            }
        }

        pa.click();


    };//imageUpload()



// ================================= Focus ===================================

    let focus_windowSize = 64
    let focus_stepSize = 32

    let data_focus = {}

    let busy_calculateFocus = false;
    let focus_ready = false;
    
    
    const focusCheck = async ()=> {

        busy_calculateFocus = true;

        focus_windowSize = Math.max(32, focus_windowSize);
        focus_stepSize = Math.max(16, focus_stepSize);

        const reply = await fetch(URL_API("camte/measure_focus"), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    ...login, imageFilename: imgFn_focus,
                    windowSize: focus_windowSize,
                    stepSize: focus_stepSize
                }
                )});

        if (reply && reply.ok) {
            data_focus = await reply.json();

            // Plot focus values
            Plotly.newPlot('plotFocus', data_focus);
            focus_ready = true;

        }
        else {
            console.log('analyze image failed');
            
        }

        busy_calculateFocus = false;

    };//distortionCheck()



// =============================== Distortion ================================


    let data_disto = {}
    let disto_corners = []


    const distortionCheck = async ()=> {

        const reply = await fetch(URL_API("camte/measure_distortion"), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    ...login, imageFilename: imgFn_disto
                }
                )});

        if (reply && reply.ok) {
            data_disto = await reply.json();

            disto_corners = data_disto["distoCorners"];

            // show image with detected circles
            imgSrc_disto = URL_IMG(data_disto["imageFilename"]);
        }
        else {
            console.log('analyze image failed');
            
        }

    };//distortionCheck()



// ========================== Interactive y-scaling ==========================


    let maxScale_focus = 50000;


    const update_maxScale = plotname => {

        let minScale = 0;
        let maxScale = 50000;
        if (plotname.includes("plotFocus")){
            maxScale = maxScale_focus;
        }
        else {
            return;
        }

        const plotUpdate = {'zmin': minScale, 'zmax': maxScale};
        Plotly.update(plotname, plotUpdate, {}, [0]);

    };//update_maxScale()


    const exportData = plotname => {

        let rows = [];
        if (plotname.includes("plotFocus")){
            rows = data_focus.data[0].z;
        }
        else {
            return;
        }
        rows.reverse();

        let csvContent = "data:text/csv;charset=utf-8,";
        rows.forEach(function(rowArray) {
            let row = rowArray.join(", ");
            csvContent += row + "\r\n";
        });

        var encodedUri = encodeURI(csvContent);
        let dl = document.createElement("a");
        dl.setAttribute("href", encodedUri);
        dl.setAttribute("download", `${plotname}.csv`);
        document.body.appendChild(dl); // Required for FF
        dl.click();

    };//exportData()


// ========================== Construction / Init ============================

    import { onMount, onDestroy } 	from 'svelte';


    onMount(async () => {

    });//onMount()


    function close(nextPage=PAGE.home) {
        dispatch('close', {page: nextPage});
    }//close()


    onDestroy(async () => {

    });//onDestroy()

</script>




<!-- =============================  H T M L  ============================= -->




<div class="page">

    <h1>Camera</h1>

    <h3>Focus, Distortion & Co</h3>



    <div class="btnRow">
        <div class="btn" on:click={()=>imageUpload('focus')}>
            Upload focus image
        </div>
        <div class="btn" on:click={()=>imageUpload('disto')}>
            Upload distortion image
        </div>
    </div>


    <div class="imgBox">
        <img src={imgSrc_focus} alt="" on:click={()=>imageUpload('focus')}>
        <img src={imgSrc_disto} alt="" on:click={()=>imageUpload('disto')}>
    </div>

    <!-- distortion results -->

    {#if disto_corners.length > 0}

    <h3>Distortion of distance corner marker to target center</h3>

    <table>
        <tr>
            <th>Marker</th>
            <th>Rel. dist. to center</th>
            <th>x [px]</th>
            <th>y [px]</th>
        </tr>
        {#each disto_corners as corner}
            <tr>
                <td>{corner.name}</td>
                <td>{corner.relDistortion.toFixed(2)} %</td>
                <td>{corner.x.toFixed(1)}</td>
                <td>{corner.y.toFixed(1)}</td>
            </tr>
        {/each}
    </table>
    {/if}

    <!-- focus estimation -->

    <h3 class:hide={(!focus_ready && !busy_calculateFocus)}>
        Heatmap of focus measurement
    </h3>

    <h2 class:hide={!busy_calculateFocus}>
        ... calculating and plotting focus measure, please wait ...
    </h2>

    <div class="box" class:hide={!focus_ready}>

        <!-- <h3>Heatmap of focus measurement</h3> -->

        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotFocus')}>
                Export data
            </div>

            <div class="box-input">
                <label for="focus_windowSize">Window size in px</label>
                <input id="focus_windowSize"  class="input-txt"
                    bind:value={focus_windowSize} on:blur={focusCheck}
                    type="number" min="32"  pattern="\d*">
            </div>
            <div class="box-input">
                <label for="focus_stepSize">Steps size in px </label>
                <input id="focus_stepSize"  class="input-txt"
                    bind:value={focus_stepSize} on:blur={focusCheck}
                    type="number" min="16"  pattern="\d*">
            </div>

            <div class="box-input">
                <label for="maxScale_focus">Scale maximum</label>
                <input id="maxScale_focus"  class="input-txt"
                    bind:value={maxScale_focus} on:input={()=>update_maxScale('plotFocus')}
                    type="number" min="1000"  pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotFocus"></div>
    </div>



</div>

<input id="imageUploadDOMEl" name="imageFile" type="file" accept="image/jpeg"  style="display:none;"/>



<!-- ============================  S T Y L E  ============================ -->



<style>
	.page {
        width: 100%;
        max-width: 1200px;
        margin-top: 2em;
        margin-left: auto;
        margin-right: auto;
        padding: 2em;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        margin-top: 3em;
    }

    h2 {
        margin: 0px;
    }

    h3 {
        border-top: 1px solid var(--tF-gray);
        padding: 1em 2em;
        margin: 2em auto 0.5em auto;
    }

    .btn {
        width: 20em;
    }

    .imgBox {
        width: 100%;
        margin: auto;
        margin-top: 4em;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .imgBox img {
        width: 40%;
        max-width: 500px;
        object-fit: contain;
    }


    .box {
        margin-top: 3em;
        width: 100%;
        max-width: 1400px;
    }

    /* .box img{
        width: 100%;
        max-width: 1200px;
        object-fit: contain;
        cursor: crosshair;
    } */

    .plot {
        width: 100%;
        min-height: 800px;
        overflow: hidden;
        margin-bottom: 3em;
        margin-left: 0px;
    }

    .btnRow {
        width: 100%;
        margin: auto;
        margin-top: 4em;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .plotHeaderRow {
        margin-top: 2em;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 0.5em;
        align-items: flex-end;
    }

</style>